import type { CityConfig } from "../city-template/types";

export const butteConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Butte",
  state: "Montana",
  stateAbbr: "MT",
  slug: "butte",
  route: "/cities/butte",
  title: "Emergency Passport Butte, MT — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Butte, MT — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Silver Bow County, Anaconda, Deer Lodge, Dillon, and southwest Montana. No Denver drive needed.",
  h1: "Emergency & Expedited Passport Services in Butte, MT",
  heroSubtitle: "Montana Tech conference in Canada next month? Mining industry business trip to Chile or Australia? Family reunion in Ireland this summer? We help Butte residents — from Uptown Butte families to Montana Tech faculty and students to southwest Montana ranchers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20view%20of%20Butte%20Montana%20historic%20mining%20town%20with%20the%20iconic%20Our%20Lady%20of%20the%20Rockies%20statue%20on%20the%20Continental%20Divide%20ridgeline%20at%20golden%20sunset%2C%20brick%20historic%20buildings%20in%20uptown%20district%20below%2C%20rugged%20mountain%20landscape%20with%20sagebrush%20and%20pine%2C%20warm%20amber%20light%2C%20cinematic%20travel%20photography%20composition%20with%20rich%20contrast%2C%20no%20people%20visible&width=1800&height=700&seq=butte-hero-2026&orientation=landscape",
  heroImageAlt: "Butte Montana historic mining town with Our Lady of the Rockies statue at sunset",
  geoPosition: "46.0038;-112.5348",
  geoPlacename: "Butte, Montana",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 510, Aurora, CO 80014",
    distance: "Nearest regional passport agency — approximately 620 miles from Butte via I-15/I-25; not practical for most southwest Montana residents",
  },
  nearbyCitiesZips: [
    { name: "Butte", zips: "59701, 59703, 59707" },
    { name: "Anaconda", zips: "59711" },
    { name: "Deer Lodge", zips: "59722" },
    { name: "Dillon", zips: "59725" },
    { name: "Whitehall", zips: "59759" },
    { name: "Boulder", zips: "59632" },
    { name: "Philipsburg", zips: "59858" },
    { name: "Townsend", zips: "59644" },
  ],
  benefits: [
    { icon: "ri-building-2-line", title: "No Denver Trip Required", desc: "Denver Passport Agency is 620 miles from Butte — completely impractical for most Silver Bow County residents. Our registered courier service handles everything remotely from Butte." },
    { icon: "ri-flight-takeoff-line", title: "BTM Airport & Regional Connections", desc: "Bert Mooney Airport connects through Salt Lake City and Denver for international departures. We coordinate timelines around BTM connections for Butte travelers." },
    { icon: "ri-graduation-cap-line", title: "Montana Tech Faculty & Student Travel", desc: "International conferences, research collaboration, study abroad programs — we help Montana Tech students and professors get passports fast for academic travel deadlines." },
    { icon: "ri-global-line", title: "Mining Industry International Travel", desc: "Butte's mining heritage spans international connections. Industry professionals traveling to Canada, Chile, Australia, and global mining conferences rely on us for fast passport processing." },
  ],
  internalLinks: [
    { name: "Expedited passport in Bozeman, MT", route: "/cities/bozeman" },
    { name: "Fast passport services in Missoula, MT", route: "/cities/missoula" },
    { name: "Quick passport services in Helena, MT", route: "/cities/helena" },
    { name: "Urgent passport services in Butte, MT", route: "/cities/butte" },
    { name: "Montana passport services overview", route: "/states/montana" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 510, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Butte via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 10+ hours to Colorado. Butte residents can ship from any UPS Store, FedEx Office, or post office location in Silver Bow County.",
  fpcOfficeDistance: "Serving Butte, Anaconda, Deer Lodge, Dillon, Whitehall, Boulder, and all southwest Montana communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Butte and southwest Montana. From Uptown Butte's historic district to Montana Tech campus, from Anaconda's Smelter City to the ranching communities of Deer Lodge and Dillon — we serve all of Silver Bow County, Deer Lodge County, and the surrounding Big Hole and Beaverhead regions. Our courier service eliminates the need to drive 620 miles to Denver.",
  nearbyCitiesIntro: "We serve Butte and all surrounding southwest Montana communities including Anaconda, Deer Lodge, Dillon, Whitehall, Boulder, Philipsburg, and Townsend. We also serve Montana Tech students, mining industry professionals, and ranchers throughout the region who need expedited passport services.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Butte as simple as possible — with the reliability Montana Tech researchers, mining professionals, and southwest Montana families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Butte travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Butte travelers face unique challenges — from BTM connection timing to mining industry visa requirements to academic conference deadlines. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Southwest Montana travelers — from Butte families to Montana Tech professors to Anaconda business owners — trust us when their international plans require a passport fast and Denver is simply too far.",
  faqIntro: "Have questions about expedited passports in Butte, MT? Here are the most common ones we hear from Silver Bow County and southwest Montana travelers.",
  statePageRoute: "/states/montana",
  statePageName: "Montana",
  servicesIntro: "Whether you need a renewal before a mining conference in Toronto, an emergency passport for a last-minute BTM connection, or a first-time passport for a Butte family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dojmt.gov/driving/",
  dmvLabel: "Montana Motor Vehicle Division — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 620 miles from Butte", "Impractical for most southwest Montana residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — entirely remote", "Ideal for upcoming international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Butte", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Mining industry trip to Chile departing this week? Family emergency in Canada tomorrow? Our emergency courier service submits via reserved slots — as fast as 24 hours for Butte-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Butte residents renew fast — no Denver agency visit required. Perfect for Silver Bow County families, Montana Tech professionals, and southwest Montana ranchers.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Butte residents through every step with clear instructions for the nearest acceptance facility in Silver Bow County.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require DS-64 and additional forms. We guide you through everything needed — so your mining industry travel or academic conference attendance is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Butte family vacation or Montana Tech student trip abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations. Common for Butte residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Butte mining consultants and business professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Butte and southwest Montana travelers through the process so international plans stay on schedule.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for southwest Montana residents crossing into Alberta.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Butte MT", description: "Urgent passport processing for Butte Montana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Butte MT", description: "Fast passport renewal for Butte Montana residents with a previously-issued passport." },
    { name: "First-Time Passport Butte MT", description: "New passport application services for Butte Montana residents applying for their first passport." },
    { name: "Child Passport Butte MT", description: "Minor passport services for Butte Montana families with children under 16." },
    { name: "Name Change Passport Butte MT", description: "Passport name correction after marriage, divorce, or legal name changes for Butte residents." },
    { name: "Second Passport Butte MT", description: "Second passport services for Butte mining industry professionals and frequent travelers." },
  ],
  testimonials: [
    {
      name: "Dr. James K.",
      location: "Montana Tech Professor — Uptown Butte",
      rating: 5,
      text: "I had an academic conference in Australia and my passport was expired. Fast Passport Center got it renewed in 6 days without me leaving Butte. Denver is a 10-hour drive — this service is a lifesaver for southwest Montana.",
      service: "Passport Renewal",
    },
    {
      name: "The Martinez Family",
      location: "Anaconda",
      rating: 5,
      text: "We planned a family trip to visit relatives in Mexico and realized two of our kids needed first-time passports. They guided us through the whole process and everything arrived on time despite living 25 miles from Butte.",
      service: "Child Passport — First Time",
    },
    {
      name: "Curtis M.",
      location: "Butte",
      rating: 5,
      text: "Mining consultant heading to Chile on short notice — 5 business days. They handled the emergency renewal start to finish. The document review caught an issue with my photo that would have caused a rejection.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Linda H.",
      location: "Dillon",
      rating: 5,
      text: "Retired teacher traveling to Ireland with a tour group. Needed a name change on my passport after getting remarried. Fast Passport Center made it simple — shipped from the Dillon post office and passport came to my door.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "butte-1",
      name: "Butte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "60 W Quartz St",
      city: "Butte",
      state: "MT",
      zip: "59701",
      phone: "(406) 723-4759",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Uptown Butte — downtown historic district",
      website: "https://tools.usps.com/find-location.htm?location=1368613",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Silver Bow County. Located in historic uptown Butte. Passport photos available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "butte-2",
      name: "Anaconda Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "218 Main St",
      city: "Anaconda",
      state: "MT",
      zip: "59711",
      phone: "(406) 563-5371",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Anaconda — about 25 miles west of Butte",
      website: "https://tools.usps.com/find-location.htm?location=1362117",
      websiteLabel: "USPS Location",
      notes: "Convenient for Anaconda and Deer Lodge area residents. Limited hours — call to confirm before visiting.",
      icon: "ri-mail-line",
    },
    {
      id: "butte-3",
      name: "Silver Bow County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "155 W Granite St",
      city: "Butte",
      state: "MT",
      zip: "59701",
      phone: "(406) 497-6340",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Uptown Butte — Silver Bow County Courthouse",
      website: "https://silverb.mt.gov/government/clerks-office/",
      websiteLabel: "Silver Bow County Clerk",
      notes: "County clerk passport acceptance at the historic courthouse. Appointment recommended. Photo services not available — bring your own.",
      icon: "ri-government-line",
    },
    {
      id: "butte-4",
      name: "Deer Lodge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "123 2nd St",
      city: "Deer Lodge",
      state: "MT",
      zip: "59722",
      phone: "(406) 846-2421",
      hours: "Mon–Fri 9:00 AM – 3:00 PM (call to confirm passport services)",
      distance: "Deer Lodge, Powell County — about 40 miles north of Butte",
      website: "https://tools.usps.com/find-location.htm?location=1369180",
      websiteLabel: "USPS Location",
      notes: "Limited hours and passport service availability. Call ahead to confirm passport acceptance is offered on your intended visit day.",
      icon: "ri-mail-line",
    },
    {
      id: "butte-5",
      name: "Dillon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "117 S Idaho St",
      city: "Dillon",
      state: "MT",
      zip: "59725",
      phone: "(406) 683-5331",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Dillon, Beaverhead County — about 65 miles south of Butte",
      website: "https://tools.usps.com/find-location.htm?location=1369382",
      websiteLabel: "USPS Location",
      notes: "Serves the Beaverhead Valley and Dillon area. Appointment required — call at least 5 days in advance during summer months.",
      icon: "ri-mail-line",
    },
    {
      id: "butte-6",
      name: "Helena Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2300 N Harris St",
      city: "Helena",
      state: "MT",
      zip: "59601",
      phone: "(406) 443-3705",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Helena — about 70 miles north of Butte",
      website: "https://tools.usps.com/find-location.htm?location=1374084",
      websiteLabel: "USPS Location",
      notes: "Larger USPS facility in the state capital. Regular passport acceptance hours and photo services. About 1 hour 15 minute drive from Butte.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 620 miles from Butte via I-15/I-25", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO; 10+ hours each way from Butte, completely impractical", fpc: "Most Butte travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove emergency with documentation", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, even worse when you are 620 miles away", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Butte", agency: "620-mile drive to Denver one way — $100+ in gas and 10+ hours driving time", fpc: "Entirely remote — forms online, ship from Butte, passport comes to your Silver Bow address" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but add travel costs, time off work, and logistics of Denver trip", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Southwest MT Context", agency: "No southwest Montana-specific guidance — no BTM, Tech, or mining industry expertise", fpc: "Full Butte/southwest Montana knowledge — BTM airport, Montana Tech, mining industry context" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Denver Agency Is Practical from Butte",
      description: "The Denver Passport Agency is 620 miles from Butte — a 10+ hour drive each way. Many Butte travelers think they can drive down for a same-day appointment, not realizing the round trip takes at least 2 full days. Our courier service makes that drive completely unnecessary.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Butte applicants often attempt the simpler renewal form when their passport was issued at age 15 or younger. A rejected form costs 1–2 weeks. We review before you submit so your academic travel or mining trip stays on schedule.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Some southwest Montana pharmacies produce photos that fail State Department standards. We catch sizing, lighting, and background issues in document review before they cause a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Butte and Anaconda families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Mining Visa Processing Times",
      description: "Mining professionals heading to Chile, Australia, or Canada often need visas on top of passports. A valid passport is step one — but visa processing adds weeks. We help Butte mining consultants plan both timelines correctly.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order from your Butte home or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you are a Montana Tech professor or an Anaconda family planning an international trip." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Butte clients ship from the UPS Store or FedEx location — no Denver trip needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Silver Bow County travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Butte, Anaconda, or Dillon address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Butte, Montana?", a: "We offer Butte-area clients expedited processing as fast as 24 hours. Standard expedited through our courier channel takes 5–10 business days. Because Butte's nearest regional passport agency is in Denver (620 miles), our remote courier service is the most practical fast option in southwest Montana." },
    { q: "Do I need to visit a Butte office?", a: "No. Our service is remote — complete forms online, visit a local acceptance facility (Butte post office, Silver Bow County Clerk, Anaconda post office), then ship documents overnight. We handle the State Department submission and return your passport to your Silver Bow County address." },
    { q: "Where can I get a passport acceptance near Butte?", a: "Butte has acceptance facilities at the Main Post Office on Quartz Street and the Silver Bow County Clerk & Recorder at the courthouse. Additional facilities are available in Anaconda, Deer Lodge, Dillon, and Helena. We maintain an updated list with hours and appointment requirements." },
    { q: "Is there a passport agency in Butte?", a: "No. Montana has no passport agency. The closest regional passport agency is the Denver Passport Agency — 620 miles from Butte. That's why our registered courier service is the most practical expedited passport option for Butte, Anaconda, and all southwest Montana residents." },
    { q: "What is the best price for expedited passport service in Butte?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping to and from our processing center, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Butte applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Silver Bow County-specific checklist." },
    { q: "Can I get a passport photo in Butte?", a: "Yes. Butte Main Post Office offers on-site passport photos. CVS, Walgreens, and Walmart in Butte also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I get to Denver Passport Agency from Butte?", a: "The Denver Passport Agency is in Aurora, CO — approximately 620 miles from Butte. The drive takes about 10 hours each way via I-15 south to I-25. For most Butte residents, our courier service is the far more practical option — we handle agency submission remotely while you stay in Montana." },
    { q: "Can you help Montana Tech students with study abroad passports?", a: "Yes. We regularly assist Montana Tech students and faculty with passports for international conferences, research collaborations, and study abroad programs. First-time passport applicants (common among students) need an acceptance facility visit — we guide you to the nearest available facility." },
    { q: "What if I'm a mining professional needing a passport fast for international travel?", a: "Butte's mining industry connections frequently require fast passports for international travel to Chile, Australia, Canada, and global mining conferences. Our expedited service handles short timelines — we have processed mining consultant passports in as fast as 3 business days." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Butte Residents",
    intro: "Butte's position in southwest Montana — far from major international airports and passport agencies — creates distinct timing challenges. Here's what Silver Bow County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BTM — Bert Mooney Airport",
        subtitle: "Butte's regional airport with connections through major hubs",
        description: "BTM connects Butte to Salt Lake City (Delta) and Denver (United). Most Butte international travelers connect through these hubs before flying overseas. The small airport's limited schedule means careful coordination is essential — a missed connection due to passport issues can strand you in Butte for a full day before the next flight.",
        tip: "BTM connections mean your passport must be valid at Butte check-in, not just at your international departure hub. Check passport validity the moment you book any international itinerary through BTM.",
      },
      {
        icon: "ri-building-2-line",
        title: "Mining Industry International Travel",
        subtitle: "Butte's historic and continuing mining connections worldwide",
        description: "Butte's mining heritage spans global connections. Modern mining consultants, engineers, and executives travel regularly to Canada (Toronto, Vancouver mining finance centers), Chile (copper mining), Australia (mining technology), and international mining conferences. These trips often surface with short notice — a corporate merger, a site visit, or a conference slot that opens unexpectedly.",
        tip: "Mining industry travelers should keep passports current at all times. When a mine site visit in Chile or a conference in Toronto surfaces with 2 weeks notice, there is no time for standard passport processing.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Montana Tech — Academic Travel & Study Abroad",
        subtitle: "International conferences, research, and student exchange programs",
        description: "Montana Technological University sends faculty and students to international conferences, research collaborations, and study abroad programs throughout the year. Engineering and geoscience conferences in Europe, research partnerships in South America, and student exchanges all require passports — often on academic timelines with fixed, unmovable dates.",
        tip: "Montana Tech students applying for study abroad should start the passport process the same week they apply to their program — not when they are accepted. Program acceptance timelines are often tighter than passport processing timelines.",
      },
      {
        icon: "ri-road-map-line",
        title: "Drive-to-Airport: BZN, HLN, and GEG Options",
        subtitle: "Alternatives when BTM flights don't work for your schedule",
        description: "Butte residents often drive to Bozeman Yellowstone International Airport (BZN, 85 miles east) or Helena Regional Airport (HLN, 70 miles north) for additional flight options. Some travelers even drive to Spokane International Airport (GEG, 260 miles west) for direct international flights. Each option adds driving time to an already tight travel schedule.",
        tip: "Factor drive time to BZN or HLN into your travel day. A 7 AM international connection from Bozeman means leaving Butte by 5 AM. Having your passport ready weeks ahead ensures the only thing you worry about is the drive, not the document.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Butte & Southwest Montana's Geographical Challenge",
      description: "Butte sits at the crossroads of I-90 and I-15, surrounded by mountains and 100+ miles from any major airport. The nearest international gateway is Spokane (GEG, 260 miles) or Salt Lake City (SLC, 410 miles). For passport emergencies, the Denver Passport Agency is 620 miles. Our courier service transforms this geographical challenge — processing your passport remotely and delivering it to your door.",
    },
  },
  destinations: {
    title: "Where Butte Travelers Go — And Why Passports Get Urgent",
    intro: "Butte's mining heritage, academic institutions, and location in southwest Montana create distinct international travel patterns. Here's what we see most frequently.",
    stats: [
      { stat: "35%", label: "of Butte expedited requests are mining industry or corporate business travel" },
      { stat: "2–3 Weeks", label: "typical lead time from booking to departure for Butte-area travelers" },
      { stat: "620 Miles", label: "distance to Denver Passport Agency — our courier service bridges this gap" },
      { stat: "4 Days", label: "shortest turnaround we have handled for a Butte mining consultant heading to Chile" },
    ],
    destinations: [
      { name: "Canada", context: "Mining finance conferences in Toronto and Vancouver, family visits in Alberta, recreational fishing trips to British Columbia", urgency: "Business conferences with 2–3 weeks notice, fishing trips booked seasonally", icon: "ri-map-pin-2-line" },
      { name: "Mexico & South America", context: "Chile copper mining site visits, Peru mining operations, Mexico resort vacations, winter snowbird destinations", urgency: "Mining site visits with 5–10 business days notice, resort vacations booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Engineering and geoscience conferences, heritage travel to Ireland and UK, Montana Tech research collaborations in Germany", urgency: "Conference dates fixed 6–12 months out, but many travelers don't check passports until 3 weeks before", icon: "ri-map-pin-2-line" },
      { name: "Australia & Pacific", context: "Mining technology conferences in Perth, mining engineering exchanges, academic collaborations", urgency: "Long-lead trips with 4–8 weeks planning, but passport renewals often forgotten until last month", icon: "ri-map-pin-2-line" },
      { name: "Caribbean", context: "Cruise departures from Seattle or Vancouver, all-inclusive resort packages, winter escape vacations", urgency: "Last-minute cruise deals booked 2–4 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Africa", context: "Mining industry operations in South Africa, Ghana, and mining conferences across the continent", urgency: "Long-haul business travel often confirmed 3–4 weeks ahead", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Montana Service Areas",
    crossLinksDesc: "We serve travelers across Big Sky Country with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Bozeman", route: "/cities/bozeman" },
      { name: "Helena", route: "/cities/helena" },
      { name: "Missoula", route: "/cities/missoula" },
    ],
  },
  photoLocations: [
    { name: "Walmart Supercenter — Butte", address: "3901 Harrison Ave, Butte, MT 59701", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Butte", address: "2501 Harrison Ave, Butte, MT 59701", hours: "Call for hours", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Butte", address: "3200 Harrison Ave, Butte, MT 59701", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/" },
    { name: "The UPS Store — Butte", address: "3111 Harrison Ave, Butte, MT 59701", hours: "Call for hours", website: "https://www.theupsstore.com/" },
    { name: "Walmart Supercenter — Helena", address: "2750 Prospect Ave, Helena, MT 59601", hours: "Daily 7 AM – 11 PM (about 70 miles from Butte)", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Bozeman", address: "1500 N 7th Ave, Bozeman, MT 59715", hours: "Call for hours (about 85 miles from Butte)", website: "https://www.fedex.com/" },
    { name: "Costco Wholesale — Bozeman", address: "2505 Catron St, Bozeman, MT 59718", hours: "Call for photo center hours", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    {
      name: "Silver Bow County Treasurer — Motor Vehicle Division",
      address: "155 W Granite St, Room 102, Butte, MT 59701",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Located in the county courthouse.",
      featured: true,
    },
    {
      name: "Montana MVD — Butte Driver Exam Station",
      address: "3615 Wynne Ave, Butte, MT 59701",
      hours: "Tue–Fri, by appointment only",
      note: "Driver license testing and renewals. REAL ID available. Appointment required.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BTM",
      name: "Bert Mooney Airport",
      distance: "About 4 miles southeast of Uptown Butte",
      address: "101 Airport Rd, Butte, MT 59701",
      note: "Regional airport serving Butte with daily Delta connections to Salt Lake City and United service to Denver. Gateway for international connections via SLC and DEN hubs.",
      flightUrl: "https://www.butteairport.com/",
      flightLabel: "Bert Mooney Airport Website",
      featured: true,
    },
    {
      code: "HLN",
      name: "Helena Regional Airport",
      distance: "About 70 miles north of Butte (1 hour 15 minutes)",
      address: "2850 Skyway Dr, Helena, MT 59602",
      note: "Larger regional airport with connections to Salt Lake City, Denver, Seattle, and Minneapolis. Alternative for Butte travelers needing more flight options.",
      flightUrl: "https://helenaairport.com/",
      flightLabel: "Helena Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Montana birth certificates from the Montana Department of Public Health and Human Services. Online, mail, or in-person at the Silver Bow County Courthouse.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Montana DPHHS Vital Records. Required for estate and legal matters in Silver Bow County.",
      url: "https://dphhs.mt.gov/vitalrecords/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Silver Bow County Clerk & Recorder. Certified copies available at the courthouse on Granite Street.",
      url: "https://silverb.mt.gov/government/clerks-office/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Silver Bow County District Court. Required for name change passport corrections.",
      url: "https://silverb.mt.gov/government/clerks-office/",
    },
  ],
};